export default __webpack_public_path__ + "static/media/home_page_nfl.be873a12.png";